import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getAuctionsList, setSearchFlag } from '../../../store/auctions/action';
import { getAutoSuggestions, setRecentSearches } from '../../../store/search/action';
import SearchAuctionModal from './component';

const mapStateToProps = ({ search: { recentSearch }, user, auctions: { type } }) => ({
    recentSearch, user, type
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getAuctionsListConnect: getAuctionsList,
    setSearchFlagConnect: setSearchFlag,
    setRecentSearchConnect: setRecentSearches,
    getAutoSuggestionsConnect: getAutoSuggestions
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SearchAuctionModal);